import React, { useRef, forwardRef } from "react";

const TermAndCondition = forwardRef(
  ({ user, terms, terminationConditions, warningMessage }, ref) => {
    const componentRef = useRef();

    const handlePrint = () => {
      window.print();
    };

    return (
      <div>
        <div style={{ textAlign: "center", marginTop: 20 }}>
          <button
            onClick={handlePrint}
            style={{
              padding: "10px 20px",
              fontSize: "16px",
              backgroundColor: "#ff0000",
              color: "#fff",
              border: "none",
              borderRadius: "5px",
              cursor: "pointer",
            }}
          >
            Print PDF
          </button>
        </div>

        {/* Design Content to Print */}
        <div id="printable-content" ref={componentRef}>
          <div
            style={{
              padding: "20px",
              border: "1px solid #000",
              width: "80%",
              margin: "auto",
              marginTop: 40,
            }}
          >
            <h1 style={{ textAlign: "center" }}>Terms And Conditions</h1>
            <div style={{ marginLeft: 20, paddingVertical: 20 }}>
              <p>MemberId: {user?.memberId}</p>
              <p>Name: {user?.fullName}</p>
              <p>Age: {user?.age}</p>
              <p>Phone Number: {user?.phoneNo}</p>
              <p>Address: {user?.address}</p>
            </div>
            <h2
              style={{
                textAlign: "center",
                fontSize: 18,
                color: "#ff0000",
                marginBottom: 10,
              }}
            >
              Membership Agreement
            </h2>
            {terms.map((item, index) => (
              <p key={index} style={{ marginBottom: 10 }}>
                {index + 1}. {item}
              </p>
            ))}
            <h2
              style={{
                textAlign: "center",
                fontSize: 18,
                color: "#ff0000",
                marginBottom: 10,
              }}
            >
              Termination Conditions
            </h2>
            {terminationConditions.map((point, index) => (
              <p key={index} style={{ marginBottom: 10 }}>
                {index + 1}. {point}
              </p>
            ))}
            <p style={{ color: "#ff0000" }}>{warningMessage}</p>

            <div
              style={{
                display: "flex",
                alignItems: "flex-end",
                flexDirection: "column",
              }}
            >
              <img
                src={`https://api.c3fitnesssciencegymgmail.com/files/${user?.signature}`}
                alt="Signature"
                style={{
                  width: 100,
                  marginBottom: 20,
                }}
              />
              <p>Signature</p>
            </div>
          </div>
        </div>
      </div>
    );
  }
);

export default TermAndCondition;
